import { createSlice } from '@reduxjs/toolkit';
import { CTAManagementState } from './types';

export const initialState: CTAManagementState = {
  list: {},
  conversion: {},
  forms: [],
  loading: false,
  postLoading: false,
  error: ''
};

const localeSlice = createSlice({
  name: 'ctaManagement',
  initialState,
  reducers: {
    fetchCTAList: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    fetchCTAListSuccess: (state, action) => {
      state.loading = false;
      state.list = action.payload;
    },
    fetchCTAListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    postConversion: (state, action) => {
      state.postLoading = true;
      state.error = '';
    },
    postConversionSuccess: state => {
      state.postLoading = false;
      state.error = '';
    },
    postConversionFailure: (state, action) => {
      state.postLoading = false;
      state.error = action.payload;
    },
    updateConversion: (state, action) => {
      state.postLoading = true;
      state.error = '';
    },
    updateConversionSuccess: state => {
      state.postLoading = false;
      state.error = '';
    },
    updateConversionFailure: (state, action) => {
      state.postLoading = false;
      state.error = action.payload;
    },
    fetchConversionDetail: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    fetchConversionDetailSuccess: (state, action) => {
      state.loading = false;
      state.conversion = action.payload;
    },
    fetchConversionDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchForms: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    fetchFormsSuccess: (state, action) => {
      state.loading = false;
      state.forms = action.payload;
    },
    fetchFormsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    postFormConversion: (state, action) => {
      state.postLoading = true;
      state.error = '';
    },
    postFormConversionSuccess: state => {
      state.postLoading = false;
      state.error = '';
    },
    postFormConversionFailure: (state, action) => {
      state.postLoading = false;
      state.error = action.payload;
    },
    updateFormConversion: (state, action) => {
      state.postLoading = true;
      state.error = '';
    },
    updateFormConversionSuccess: state => {
      state.postLoading = false;
      state.error = '';
    },
    updateFormConversionFailure: (state, action) => {
      state.postLoading = false;
      state.error = action.payload;
    },
    deleteConversion: (state, action) => {
      state.postLoading = true;
      state.error = '';
    },
    deleteConversionSuccess: state => {
      state.postLoading = false;
      state.error = '';
    },
    deleteConversionFailure: (state, action) => {
      state.postLoading = false;
      state.error = action.payload;
    },
    resetConversion: state => {
      state.conversion = null;
    },
    resetState: () => {
      return initialState;
    }
  }
});

export const {
  fetchCTAList,
  fetchCTAListSuccess,
  fetchCTAListFailure,
  postConversion,
  postConversionSuccess,
  postConversionFailure,
  updateConversion,
  updateConversionSuccess,
  updateConversionFailure,
  fetchConversionDetail,
  fetchConversionDetailSuccess,
  fetchConversionDetailFailure,
  fetchForms,
  fetchFormsSuccess,
  fetchFormsFailure,
  postFormConversion,
  postFormConversionSuccess,
  postFormConversionFailure,
  updateFormConversion,
  updateFormConversionSuccess,
  updateFormConversionFailure,
  deleteConversion,
  deleteConversionSuccess,
  deleteConversionFailure,
  resetConversion,
  resetState
} = localeSlice.actions;

export default localeSlice.reducer;
